import {
  collection,
  deleteDoc,
  doc,
  setDoc,
  type QueryDocumentSnapshot,
} from 'firebase/firestore';
import type { EntityDocument, EntityDocumentEntityType } from '../types';
import { db } from './firebase';
import { COLLECTION_ENTITY_DOCUMENTS, ownedItemDocId } from './firestorePaths';

export function docToEntityDocument(d: QueryDocumentSnapshot): EntityDocument {
  const x = d.data() as Record<string, unknown>;
  const now = new Date().toISOString();
  const parts = d.id.split('__');
  const fallbackId = parts.length > 1 ? parts.slice(1).join('__') : d.id;

  const entityTypeRaw = x.entityType;
  const entityType: EntityDocumentEntityType =
    entityTypeRaw === 'investment' ||
    entityTypeRaw === 'real_estate' ||
    entityTypeRaw === 'financial_item'
      ? entityTypeRaw
      : 'financial_item';

  return {
    id: typeof x.id === 'string' && x.id.trim() ? x.id.trim() : fallbackId,
    userId: typeof x.userId === 'string' ? x.userId : '',
    entityType,
    entityId: typeof x.entityId === 'string' ? x.entityId.trim() : '',
    fileName: typeof x.fileName === 'string' && x.fileName.trim() ? x.fileName.trim() : 'Document',
    storagePath: typeof x.storagePath === 'string' ? x.storagePath : '',
    downloadUrl: typeof x.downloadUrl === 'string' ? x.downloadUrl : '',
    contentType: typeof x.contentType === 'string' ? x.contentType : 'application/octet-stream',
    sizeBytes: typeof x.sizeBytes === 'number' && Number.isFinite(x.sizeBytes) ? x.sizeBytes : 0,
    extractedText:
      typeof x.extractedText === 'string' && x.extractedText.trim() ? x.extractedText : undefined,
    notes: typeof x.notes === 'string' && x.notes.trim() ? x.notes.trim() : undefined,
    uploadedAt: typeof x.uploadedAt === 'string' ? x.uploadedAt : now,
    updatedAt: typeof x.updatedAt === 'string' ? x.updatedAt : now,
  };
}

export async function saveEntityDocument(userId: string, document: EntityDocument): Promise<void> {
  const id = document.id.trim();
  if (!id) throw new Error('Document id is required.');

  const now = new Date().toISOString();
  const payload: EntityDocument = {
    ...document,
    id,
    userId,
    updatedAt: now,
    uploadedAt: document.uploadedAt || now,
  };

  await setDoc(doc(db, COLLECTION_ENTITY_DOCUMENTS, ownedItemDocId(userId, id)), payload);
}

export async function deleteEntityDocumentRecord(userId: string, documentId: string): Promise<void> {
  const trimmedId = documentId.trim();
  if (!trimmedId) throw new Error('Document id is required.');
  await deleteDoc(doc(db, COLLECTION_ENTITY_DOCUMENTS, ownedItemDocId(userId, trimmedId)));
}

export function entityDocumentsCollectionRef() {
  return collection(db, COLLECTION_ENTITY_DOCUMENTS);
}
